import { CopyButton } from "../../../../../common/Components/Buttons/CopyButton";
import { DownloadFileButton } from "../../../../../common/Components/Buttons/DownloadFileButton";
import { RenameObjectInput } from "../../../../../common/RenameObjectInput";
import { ResearchValue } from "../../../../../services/api/instances/researchApi/types";
import { NormalizedStorageObject } from "../../../../../services/api/instances/storageApi/types/object_types";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { AppUnderlinedTitle } from "../../../../../shared/components/AppUnderlinedTitle";
import { selectUserArtifactGroup } from "../../../../Auth/redux/selectors";
import styles from "./styles.module.css";

interface Props {
  selectedObject: NormalizedStorageObject<ResearchValue> | null;
  markdownRef: React.RefObject<HTMLDivElement>;
  onDownload: () => void;
  isDisabledBtn?: boolean;
}

export const ResultHeader = ({
  selectedObject,
  markdownRef,
  onDownload,
  isDisabledBtn,
}: Props) => {
  const artifacts = useAppSelector(selectUserArtifactGroup);
  return (
    <AppUnderlinedTitle
      leftContent={
        <RenameObjectInput
          service={"research"}
          inputType={"input"}
          isDisabled={
            selectedObject?.value?.research_object?.run_id !== null ||
            !selectedObject?.write
          }
        />
      }
    >
      <div className={styles["actions-container"]}>
        {artifacts && (
          <DownloadFileButton
            onDownload={onDownload}
            isDisabled={isDisabledBtn}
          />
        )}
        <CopyButton
          copyObjectRef={markdownRef}
          copyFormat={"both"}
          className={styles["copy-button"]}
        />
      </div>
    </AppUnderlinedTitle>
  );
};
